export const UserAuth = () => {
    const getUserAuthInfo = `
        {
            user  {
                onlineUserId
                signedIn
                recognized
                registered
                loyaltyActiveFlag
                loyaltyGlobalIdentifier
                anonymousUser
                emailAddress
                checkoutEmailAddress
                firstName
                lastName
                fullName
            }
        }`;

    return getUserAuthInfo;
};
